// src/services/utils/sensores.js

/**
 * Normaliza una clave para comparación:
 * Pasa a minúsculas, quita tildes/acentos y convierte guiones bajos a espacios.
 */
function normalizeKey(key) {
  if (!key) return "";
  return String(key)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/_/g, " ");
}

/**
 * Convierte el arreglo de sensores del backend en un diccionario de fácil acceso.
 */
export function sensorMap(dispositivo) {
  const rows = dispositivo?.dispositivo_sensores || [];
  // console.log(`Sensores de ${dispositivo.nombre_dispositivo}:`, rows);

  return Object.fromEntries(
    rows
      .map((row) => {
        // Extrae la clave priorizando clave_broker o nombre
        const rawKey = row.sensor?.clave_broker || row.clave_broker || row.sensor?.nombre || row.nombre || "";
        const key = normalizeKey(rawKey);

        // Extrae el valor
        let val = row.valor_actual;
        if (typeof val === "object" && val !== null) {
          val = val.value ?? val.valor ?? val.valor_actual ?? val;
        }

        return [key, val];
      })
      .filter(([key]) => key.length > 0),
  );
}

/**
 * Obtiene un valor numérico buscando sinónimos por si el backend usa nombres distintos.
 */
export function getNumber(sensorMapObj, key, fallback = null) {
  const safeKey = normalizeKey(key);

  const aliases = {
    "temp inyeccion": ["temp inyeccion", "temperatura inyeccion", "supply temp", "temp supply", "t inyeccion"],
    "temp retorno": ["temp retorno", "temperatura retorno", "return temp", "temp return", "t retorno"],
    setpoint: ["setpoint", "temp objetivo", "temperatura objetivo", "target temp"],
    modo: ["modo", "mode", "estado"],
  };

  const possibleKeys = aliases[safeKey] || [safeKey];

  for (const k of possibleKeys) {
    const val = sensorMapObj[k];

    if (val !== undefined && val !== null && val !== "") {
      const valStr = String(val).replace(",", ".");
      const n = Number(valStr);
      if (Number.isFinite(n)) return n;
    }
  }

  return fallback; // Devuelve 0 si no encuentra nada
}
